import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "finance-dashboard stock-dashboard" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column is-12 box has-background-grey-darker" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_6 = { class: "category" }
const _hoisted_7 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_8 = { class: "category" }
const _hoisted_9 = { class: "category" }
const _hoisted_10 = { class: "asset-category mb-5 box has-background-grey-dark" }
const _hoisted_11 = { class: "category" }
const _hoisted_12 = { class: "category" }
const _hoisted_13 = { class: "category" }
const _hoisted_14 = { class: "category" }
const _hoisted_15 = {
  key: 0,
  class: "asset-category mb-5 box has-background-grey-dark"
}
const _hoisted_16 = { class: "category" }
const _hoisted_17 = { class: "category" }
const _hoisted_18 = { class: "category" }
const _hoisted_19 = { class: "category" }
const _hoisted_20 = { class: "category" }
const _hoisted_21 = { class: "category" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title-wrap" }, [
          _createElementVNode("h1", { class: "title mb-5" }, "Dashboard")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-wrap" }, [
              _createElementVNode("h1", { class: "title is-4" }, "My Orders")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_RouterLink, { to: { name: 'customer-orders-list' } }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-tablet-alt"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Orders", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title-wrap" }, [
              _createElementVNode("h1", { class: "title is-4" }, "Builder Tools")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: { name: 'strats-list' } }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-strategy"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Strategies", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_RouterLink, { to: { name: 'custom-page-builder' } }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-slideshow"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Page Builder", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-wrap" }, [
              _createElementVNode("h1", { class: "title is-4" }, "Live Quotes")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-custom' } }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-thumbnail"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Custom Page", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-alerts' } }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-notification"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Alert spreads", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_RouterLink, { to: { name: 'yield' } }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-scaling"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "Yield spreads", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_RouterLink, { to: { name: 'stream-futures' } }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("div", { class: "asset" }, [
                    _createElementVNode("div", { class: "asset-logo" }, [
                      _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "lnil lnil-house-plan"
                      })
                    ])
                  ], -1),
                  _createElementVNode("div", { class: "asset-name" }, "House indices", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          (_ctx.isStaff)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title-wrap" }, [
                  _createElementVNode("h1", { class: "title is-4" }, "Staff Area")
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_RouterLink, { to: { name: 'drift' } }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-analytics-alt-1"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "Drift", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_RouterLink, { to: { name: 'yield-check' } }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-target-alt-1"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "Yield check", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_RouterLink, { to: { name: 'orders-list' } }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-tablet-alt"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "Orders list", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_RouterLink, { to: { name: 'endofdayrepo' } }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-sales-report"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "EOD repo", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_RouterLink, { to: { name: 'repo-history' } }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-layers"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "Repo history", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_RouterLink, { to: { name: 'group-page-builder-users' } }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("div", { class: "asset" }, [
                        _createElementVNode("div", { class: "asset-logo" }, [
                          _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "lnil lnil-mask"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "asset-name" }, "Groups", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}